import DOMPurify from 'dompurify'
import { PostTypes } from '#app/config/constants.tsx'

function getContentFromHeadingTwo(json: any): string[] {
	const content: string[] = []
	if (json.children) {
		json.children.forEach((child: any) => {
			if (child.type === 'heading-two') {
				content.push(child.children[0].text)
			} else if (child.children) {
				content.push(...getContentFromHeadingTwo(child))
			}
		})
	}
	return content
}

function createIdForHeading(heading: string) {
	return heading
		.replace(/[^\w\s]/g, '')
		.replace(/\s+/g, '-')
		.toLowerCase()
}

function replaceSpaceWithUnderscore(str: string): string {
	return str.toLowerCase().replace(/\s/g, '_')
}

// code a method that removes any non letter or number from the end of a string
// and returns the new string
function trimNonLetterOrNumber(str: string): string {
	return str.replace(/[^a-zA-Z0-9]+$/g, '')
}

function getValue<T, K extends keyof T>(
	obj: T | undefined,
	path: string,
	defaultValue: T[K] | null = null,
) {
	if (!obj) return defaultValue

	const keys = path.split('.') as (keyof T)[]
	let result: any = obj

	for (const key of keys) {
		if (result && key in result) {
			result = result[key]
		} else {
			return defaultValue
		}
	}

	return result as T[K] | null
}

function addTrailingZeroes(amount: number) {
	let amountDecimals = amount.toString().split('.')[1]
	if (!amountDecimals) return `${amount}.00`

	return amountDecimals?.length >= 2 ? amount : `${amount}0`
}

const buildLinkPath = (posttype: string, slug: string) => {
	switch (posttype) {
		case PostTypes.Study:
			return `/study-notes/${slug}`
		case PostTypes.GrapeVarietals:
			return `/grape-varietals/${slug}`
		default:
			return `/wine-journal/${slug}`
	}
}

function truncateExcerpt(text: String, maxLength = 150) {
	if (text.length <= maxLength) {
		return text
	}

	let truncated = text.slice(0, maxLength)

	const lastSpaceIndex = truncated.lastIndexOf(' ')

	if (lastSpaceIndex !== -1) {
		truncated = truncated.slice(0, lastSpaceIndex)
	}

	return `${truncated}...`
}

function sanitizeInput(input: string): string {
	return DOMPurify.sanitize(input)
}

export {
	getContentFromHeadingTwo,
	replaceSpaceWithUnderscore,
	trimNonLetterOrNumber,
	createIdForHeading,
	getValue,
	addTrailingZeroes,
	buildLinkPath,
	truncateExcerpt,
	sanitizeInput,
}
